<template>
	<div v-if="$root.loading"></div>
	<div v-else class="document page-break">
		<div>
			<p><b class="company_label">Продавец: {{ $root.licentiate.short_name }}</b>
			<br>Адрес: {{ $root.licentiate.ur_adress }}
			<br>ИНН/КПП: {{ $root.licentiate.inn }}/ {{ $root.licentiate.kpp }}
			<br>Расчетный счет: {{ $root.licentiate.settlement_account }}
			<br>Кор. счет: {{ $root.licentiate.correspondent_account }}
			<br>БИК: {{ $root.licentiate.bic }}
			<br>Банк: {{ $root.licentiate.bank_name	}}</p>
		</div>
		<div>
			<p><b class="company_label">Покупатель: {{ $root.sublicentiate.short_name }}</b>
			<br>Адрес: {{ $root.sublicentiate.ur_adress }}
			<br>ИНН/КПП: {{ $root.sublicentiate.inn }}/ {{ $root.sublicentiate.kpp }}
			<br>Расчетный счет: {{ $root.sublicentiate.settlement_account }}
			<br>Кор. счет: {{ $root.sublicentiate.correspondent_account }}
			<br>БИК: {{ $root.sublicentiate.bic }}
			<br>Банк: {{ $root.sublicentiate.bank_name	}}</p>
		</div>
		<div>
			<h2 class="h"><b>Счет №  {{ $root.contract.number }} от {{ $root.contract.date }}</b></h2>
		</div>
		<div class="spcf_table">
			<table class="table table-bordered" cellpadding="6">
				<tbody>
					<tr>
						<th>№ п.п.</th>
						<th>Наименование</th>
						<th>Единица измерения</th>
						<th>Количество лицензий</th>
						<th>Цена, руб.</th>
						<td><b>Сумма(без НДС)</b><br></td>
					</tr>
					<tr v-for="item, index in $root.products">
						<td>{{ index+1 }}</td>
						<td>{{ item.full_name }} сроком на {{ item.license_period }} месяцев.</td>
						<td>шт.</td>
						<td>{{ item.license_count }}</td>
						<td>{{ item.license_price }}</td>
						<td>{{ item.license_total_sum }}</td>
					</tr>
					<tr>
						<td></td>
						<th colspan="4">Итого:</th>
						<th>{{ $root.contract.total_sum  }}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row" style="margin-top: 80px;">
			<div class="col">
				<p>
					{{ $root.licentiate.position }}
					<br>_________________/{{ $root.licentiate.director_short }}/
					<br>М.П.
				</p>
					<div class="sign_area">
						<div class="sign"></div>
					</div>
			</div>
		</div>
		<Save_instruction/>
	</div>
</template>

<script>
	import Save_instruction from '../../Save_instruction.vue'
	export default{
		mounted(){
			if(!this.$root.document_number){
				this.$router.push('/documents/'+this.$route.params.id)
			}
			document.title = "Счёт_"+this.$root.document_number;
		},
		components: {
			Save_instruction
		}
	}
</script>
